import { formatDate } from "@/lib/datetime";

export function presenceGuestDisplayName(
  guestName: string | null | undefined,
  genericLabel: string,
): string {
  const trimmed = guestName?.trim();
  return trimmed || genericLabel;
}

/** Format a presence calendar date (`YYYY-MM-DD`) without UTC day-shift. */
export function formatPresenceCalendarDate(date: string): string {
  return formatDate(`${date}T00:00:00`, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}
